var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"repeat-option-warning"},[_c('strong',[_vm._v("\n\t\t"+_vm._s(_vm.$t('calendar', 'The recurrence definition of this event is not fully supported by Nextcloud. If you edit the recurrence-options, certain recurrences may be lost.'))+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }